import { connect } from 'react-redux'
import { SubmitLead } from '#/store/actions/property'
import LeadForm from './LeadForm'

const mapStateToProps = (state: TopHap.StoreState) => ({ asyncStatus: state.global.status })

const mapDispatchToProps = { submitLead: SubmitLead }

export default connect(mapStateToProps, mapDispatchToProps)(LeadForm)
